(() => {
  angular
    .module('gm.common.utils', [])
    .factory('GmyUtils', GmyUtils);

  function GmyUtils(
    $window,
    $log,
    $document,
    $timeout
  ) {
    'ngInject';

    const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.\w+$/;

    return {
      getQuerystring,
      isEmail,
      isToday,
      mergeObjects,
      padString,
      postData,
      queryString,
      randomFloatFromInterval,
      randomIntFromInterval,
      responsePostMessage,
      selectElementText,
      throttle,
      uriToBlob,
      waitPostMessage
    };

    function getQuerystring(key) {
      const query = $window.location.search.substring(1);
      const vars = query.split('&');

      for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=');

        if (pair[0] === key) {
          return pair[1];
        }
      }
      return false;
    }

    function isEmail(email) {
      return EMAIL_REGEXP.test(email);
    }

    function isToday(date) {
      return $window.moment(date).isSame($window.moment(), 'day');
    }

    function mergeObjects(objTo, objFrom) {
      Object.keys(objFrom).forEach((key) => {
        if (angular.isObject(objFrom[key]) && angular.isObject(objTo[key])) {
          this.mergeObjects(objTo[key], objFrom[key]);
        } else {
          objTo[key] = objFrom[key];
        }
      });
    }

    function padString(origStr, width, z = '0') {
      const str = `${origStr}`;
      return str.length >= width ? str : new Array((width - str.length) + 1).join(z) + str;
    }

    function postData(url, data, target) {
      const form = $window.$('<form></form>');

      form.attr('method', 'post');
      form.attr('action', url);
      if (target) {
        form.attr('target', target);
      }

      $window.$.each(data, (key, value) => {
        const field = $window.$('<input></input>');

        field.attr('type', 'hidden');
        field.attr('name', key);
        field.attr('value', value);

        form.append(field);
      });

      // The form needs to be a part of the document in
      // order for us to be able to submit it.
      $window.$($document[0].body).append(form);
      form.submit();
    }

    function queryString(obj) {
      return Object.keys(obj).map(k => ((obj[k] === null)
        ? encodeURIComponent(k)
        : `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)).join('&');
    }

    function randomFloatFromInterval(min, max, decimals = 3) {
      return ((Math.random() * (max - min)) + min).toFixed(decimals);
    }

    function randomIntFromInterval(min, max) {
      return Math.floor((Math.random() * ((max - min) + 1)) + min);
    }

    function responsePostMessage(data, e) {
      e.source.postMessage(JSON.stringify(data), e.origin);
    }

    function selectElementText(element) {
      let range;
      let selection;

      if ($window.getSelection && $document[0].createRange) {
        selection = $window.getSelection();
        range = $document[0].createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
      } else if ($document[0].selection && $document[0].body.createTextRange) {
        range = $document[0].body.createTextRange();
        range.moveToElementText(element);
        range.select();
      }
    }

    function throttle(fn, time) {
      let _timeout;

      return (...params) => {
        if (_timeout) {
          $timeout.cancel(_timeout);
        }

        _timeout = $timeout(() => fn.apply(this, params), time);

        return _timeout;
      };
    }

    function uriToBlob(fileUri) {
      const contentTypePos = fileUri.indexOf(',');
      const contentType = fileUri.substr(5, contentTypePos - 12);
      const fileContent = atob(fileUri.substr(contentTypePos + 1));
      const array = [];

      for (let i = 0; i < fileContent.length; i += 1) {
        array.push(fileContent.charCodeAt(i));
      }

      return new Blob([new Uint8Array(array)], {
        type: contentType
      });
    }

    function waitPostMessage(name, cb) {
      const $win = angular.element($window);
      const processCb = (e) => {
        let data;

        if (e.originalEvent.data && (typeof e.originalEvent.data) === 'string') {
          try {
            data = JSON.parse(e.originalEvent.data);
          } catch (exp) {
            data = null;
            $log.error(exp);
          }

          if (data && data.type === name) {
            $win.off('message', processCb);
            cb(data, e.originalEvent);
          }
        }
      };

      $win.on('message', processCb);
    }
  }
})();
